<template>
  <div id="app">
	<div id="logo">
		<img alt="stickers | saynomore.lt" src="./assets/logo.png">
		<span>stickers | saynomore.lt</span>
	</div>
    <ImageUpload/>
  </div>
</template>

<script>
import ImageUpload from './components/ImageUpload.vue'

export default {
  name: 'App',
  components: {
    ImageUpload
  }
}
</script>

<style>
body, html, #app {
	padding:0;
	margin:0;
  width:100%;
  height:100%;

}

#app {
  font-family: "Helvetica Neue", Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-image: url("data:image/gif;base64,R0lGODlhCgAKAIAAAOLi4v///yH5BAAHAP8ALAAAAAAKAAoAAAIRhB2ZhxoM3GMSykqd1VltzxQAOw==");
}

#app #logo img {
	vertical-align:middle;
	width:120px;
	padding:10px;
}

#app #logo {
	font-weight: bold;
	font-size:3em;
	margin-bottom:100px;
}
</style>
